import {
  consoleFancyClient,
  extractData,
  type FancyOk,
  type fancyOperations
} from '@frontrow/console/src/open-api/clients'

// `storeCategory` is `Text` on the backend (Freckle/Api/Handlers/PiggyStore.hs),
// not the `StoreCategory` enum, so it stays a `string`.
export type StoreCategoryVariationT = FancyOk<
  fancyOperations['getPiggyStoreCategoryVariationsR']
>[number]

export async function fetchStoreCategoryVariations(): Promise<Array<StoreCategoryVariationT>> {
  return extractData(await consoleFancyClient.GET('/2/piggy-store/category-variations'))
}
